import { connect } from 'react-redux';

import FilterCheckboxComponent
  from '../Components/FilterCheckboxComponent';
import { changeRegressionFilter } from './../actions';
import { getRegressionFilters } from './../reducers';
import { regressionPages } from './../helpers';

export const mapStateToProps = state => {
  return {
    filters: [...regressionPages.REGRESSION_BUILD_TYPES],
    currentFilters: getRegressionFilters(state)
  };
};

export default connect(
  mapStateToProps,
  { onFilterChange: changeRegressionFilter }
)(FilterCheckboxComponent);


// WEBPACK FOOTER //
// src/Containers/RegressionFilterContainer.jsx